(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/game-list-new/assets/javascripts/column-components/game-buy-share-button.js') >= 0) return;  svs.modules.push('/components/marketplace/game-list-new/assets/javascripts/column-components/game-buy-share-button.js');

'use strict';

const GameBuyShareButton = _ref => {
  let {
    activatedDrawId,
    containerId,
    game,
    groupId,
    memberId,
    hasSelectNumberOfShares = false,
    className = ''
  } = _ref;
  const baseClassName = 'game-buy-share-button';
  const combinedClassName = "".concat(baseClassName, " ").concat(className).trim();
  return React.createElement(svs.components.marketplace.fractionPayment.FractionPayment, {
    activatedDrawId: activatedDrawId,
    className: combinedClassName,
    containerId: containerId,
    game: game,
    groupId: groupId,
    hasSelectNumberOfShares: hasSelectNumberOfShares,
    isSmall: true,
    memberId: memberId
  });
};
setGlobal('svs.components.marketplace.gameListNew.columnComponents.GameBuyShareButton', GameBuyShareButton);

 })(window);